import { ImportHistoryState } from './types'

export const initialImportHistoryState: ImportHistoryState = {
  entries: {},
  pagination: {},
}
